import * as React from 'react';
import {enhance} from './enhancer';
import {BansForm} from './../../../components/Bans';
import {setState} from './stete';
import {lifecycle} from './lifecycle';
import {handler} from './handler';

function Edit(props: any) {
  const state = setState();
  lifecycle.componentDidMount(props);

  return (
    <div className="a__bans-edit">
      <div className="b__title c__after-title">
        <h1>禁止ワードの詳細</h1>
      </div>
      <div className="b__form">
        <BansForm edit {...{...props, ...state, ...handler}} />
      </div>
    </div>
  );
}

export default enhance((props: any) => <Edit {...props} />);
